exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".text-area{padding:10px}.title{font-size:20px;font-weight:700}.subTitle{font-size:18px;font-weight:700}", ""]);

// exports
